import { isAuthenticated } from '@/auth';

export default {
  isAuthenticated
}